import React from 'react';

const PageTitleJournalSingle = () => {
    return (
        <section id="page-title">
            <div className="wrapper">
                <div className="title">
                    <h1 className="large">Memorable Wedding Rings</h1>
                </div>

                <div className="spacer m-top-md">
                    <div className="row gutter-width-md">
                        <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><a href={ process.env.PUBLIC_URL + "/Blog" }>Home</a></li>
                                    <li className="breadcrumb-item active" aria-current="page">Blog</li>
                                </ol>
                            </nav>
                        </div>

                        <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <div className="description-3">
                                <p>Memorable Wedding Rings</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default PageTitleJournalSingle;
